var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "edit-table-canvas" }, [
    _c("div", { staticClass: "edit-table-title" }, [
      _vm._v(_vm._s(_vm.data_title))
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "canvas_box",
        style: {
          width: _vm.table_width + "px",
          height: _vm.table_height + "px"
        }
      },
      [
        _c("array-canvas", {
          attrs: {
            data: _vm.data,
            editable: _vm.editable == 1 || _vm.editable == 3
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { ref: "table_box", staticClass: "table_box" },
      [
        _c("array-table", {
          attrs: {
            data: _vm.data,
            cell_width: _vm.cell_width,
            editable: _vm.editable == 2 || _vm.editable == 3
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }